export * from './enviromentCodes';
export const DEFAULT_TENANT = 'uk';
//# sourceMappingURL=index.js.map